import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/Common/Button';
import { Settings, Loader2, LogOut, Info } from 'lucide-react';

const SetupPending = () => {
  const navigate = useNavigate();
  const { isSetupCompleted, logout, refreshSetupStatus } = useAuth();
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    // Kurulum tamamlandıysa ana sayfaya at
    if (isSetupCompleted) {
      navigate('/');
      return;
    }

    // Polling: Her 10 saniyede bir kontrol et
    const interval = setInterval(async () => {
      const completed = await refreshSetupStatus();
      if (completed) {
        navigate('/');
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [isSetupCompleted, navigate, refreshSetupStatus]);

  const handleManualCheck = async () => {
    setChecking(true);
    try {
      const completed = await refreshSetupStatus();
      if (completed) {
        navigate('/');
      }
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-gray-100 p-8 text-center animate-in fade-in zoom-in duration-500">
        <div className="relative w-24 h-24 mx-auto mb-8">
          <div className="absolute inset-0 bg-primary-100 rounded-full animate-ping opacity-25"></div>
          <div className="relative z-10 w-24 h-24 bg-primary-50 text-primary-600 rounded-full flex items-center justify-center">
            <Settings size={48} className="animate-spin duration-3000" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">Ofis Kurulumu Devam Ediyor</h1>
        <p className="text-gray-500 mb-8">
          Yöneticiniz ofis kurulumunu tamamladığında otomatik olarak yönlendirileceksiniz. Lütfen bekleyin.
        </p>

        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 flex items-start gap-3 text-left">
            <Info size={20} className="text-blue-500 shrink-0 mt-0.5" />
            <p className="text-sm text-blue-700">
              Bu ekran, ofisinizin ilk ayarları (departmanlar, yetkiler vb.) yapılana kadar görünür kalacaktır.
            </p>
          </div>

          <Button 
            variant="outline" 
            className="w-full h-12" 
            onClick={handleManualCheck}
            loading={checking}
            icon={<Loader2 size={18} className={checking ? 'animate-spin' : ''} />}
          >
            Şimdi Kontrol Et
          </Button>

          <hr className="my-6 border-gray-100" />

          <button 
            onClick={logout}
            className="flex items-center justify-center gap-2 w-full py-2 text-gray-500 hover:text-red-600 transition-colors text-sm font-medium"
          >
            <LogOut size={18} />
            Sistemden Çıkış Yap
          </button>
        </div>
      </div>

      <div className="mt-8 text-gray-400 text-sm flex items-center gap-2">
        <Loader2 size={14} className="animate-spin" />
        Sistem durumunu otomatik olarak takip ediyoruz...
      </div>
    </div>
  );
};

export default SetupPending;
